export default __webpack_public_path__ + "static/media/segre12.cd424ffa.jpg";